import { motion, useAnimation, useInView } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';
import Data from './Data';
import './home.css';
import ScrollDown from './ScrollDown';
import Social from './Social';

const Home = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { 
    once: false,
    threshold: 0.2,
    margin: "-100px"
  });
  const controls = useAnimation();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [Toggle, showMenu] = useState(false);
  const [activeNav, setActiveNav] = useState('#home');
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      setIsDarkMode(savedTheme === 'dark');
    } else {
      setIsDarkMode(false);  // Default ke light mode jika tidak ada tema
    }
  }, []);
  
  useEffect(() => {
    document.body.classList.toggle('dark-mode', isDarkMode);
    document.body.classList.toggle('light-mode', !isDarkMode);
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);
  
  // Menyimpan tema ke localStorage dan mengatur class body
  useEffect(() => {
    document.body.className = isDarkMode ? 'dark-mode' : 'light-mode';
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  useEffect(() => {
    // Add stagger effect to social icons
    const socialIcons = document.querySelectorAll('.home__social-icon');
    socialIcons.forEach((icon, index) => {
      icon.style.animationDelay = `${index * 0.2}s`;
      icon.style.animation = 'fadeIn 0.5s ease backwards';
    });
  }, []);

  useEffect(() => {
    if (isInView) {
      controls.start('visible');
    } else {
      controls.start('hidden');
    }
  }, [isInView, controls]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleTheme = () => {
    setIsDarkMode((prevMode) => !prevMode);
  };

  const containerVariants = {
    hidden: { 
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const contentVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const getContentVariants = () => {
    if (windowWidth <= 576) {
      return {
        hidden: { opacity: 0 },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.1
          }
        }
      };
    }
    return contentVariants;
  };

  const itemVariants = {
    hidden: { 
      opacity: 0,
      y: 20,
      scale: 0.95
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        damping: 12,
        stiffness: 100
      }
    }
  };

  return (
    <motion.section 
      className="home section" 
      id="home"
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={containerVariants}
    >
      <motion.div 
        className="home__container container grid"
        variants={getContentVariants()}
      >
        <motion.div 
          className="home__content grid"
          variants={getContentVariants()}
        >
          <motion.div
            variants={itemVariants}
            custom={0}
          >
            <Social />
          </motion.div>

          <motion.div 
            className="home__img"
            variants={itemVariants}
            custom={1}
            initial={{ opacity: 1, scale: 1 }} // Set initial state
            animate={{ opacity: 1, scale: 1 }} // Match initial state
            whileHover={{ scale: 1.05 }}
            transition={{ 
              type: "spring",
              stiffness: 300,
              duration: 0.1 // Faster transition
            }}
          />

          <motion.div 
            variants={itemVariants}
            custom={2}
          >
            <Data />
          </motion.div>
        </motion.div>

        <motion.div
          variants={itemVariants}
          custom={3}
          style={{ 
            position: 'relative',
            transform: 'none',
            userSelect: 'none',
            touchAction: 'manipulation'
          }}
          animate={{ y: 0 }}
          whileHover={false}
          whileTap={false}
        >
          <ScrollDown />
        </motion.div>
      </motion.div>
    </motion.section>
  );
};

export default Home;
